import * as React from 'react';
import { resolve } from 'inversify-react';
import { observer } from 'mobx-react';

import { Column, DataTableView, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { FormatService } from 'src/core/services/format.service';
import { DropdownView } from 'src/core/ui/dropdown.view';
import { InvoiceEditorController } from '../../invoices/parts/invoice-editor.controller';
import { PaymentInvoicesList } from 'src/app/accounting/shared/payments/parts/payment-invoices-list';

interface Props extends ComponentViewProps<DataSet<PaymentSummary>> {
	hideStatus?: boolean;
}

@observer
export class PaymentListView extends React.Component<Props, {}> {
	@resolve
	private formatService: FormatService;

	private renderDate = (value: Date): React.ReactNode => (
		<React.Fragment>
			{this.formatService.toString('date', value, 'utc')}
			<br />
			{this.formatService.toString('time', value, 'utc')}
		</React.Fragment>
	);

	private handleExpandedRowRender = (entry: PaymentSummary): React.ReactNode => (
		<PaymentInvoicesList
			model={entry}
			setBusy={this.props.setBusy}
		/>
	);

	rowKey = (record: InvoiceSummary): string =>
		record.id.toString();

	render(): React.ReactNode {
		const { model, hideStatus } = this.props;
		if (model == null) {
			return null;
		}

		const columns: Column[] = [
			{
				title: 'Method',
				key: 'method',
				width: 100,
				render: (field: number, record: PaymentSummary) => record.methodText
			},
			{
				title: 'Payment Reference',
				key: 'paymentReference',
				dataIndex: 'paymentReference',
				width: 150
			},
			{
				title: 'Payment Date',
				key: 'paymentDate',
				dataIndex: 'paymentDate',
				width: 150,
				render: this.renderDate
			},
			{
				title: 'Currency',
				key: 'currencyIsoCode',
				dataIndex: 'currencyIsoCode',
				width: 100
			},
			{
				title: 'Amount',
				key: 'amount',
				dataIndex: 'amount',
				width: 100,
				render: (field: number, record: PaymentSummary) => this.formatService.toString('currency', field, record.currencyFormat)
			},
			{
				title: 'Description',
				key: 'description',
				dataIndex: 'description',
				width: 400
			}
		];

		if (!hideStatus) {
			columns.unshift({
				title: 'Status',
				key: 'status',
				dataIndex: 'status',
				width: 200,
				render: (field: number, record: PaymentSummary) => (
					record.statusText
				),
				filter: {
					field: 'status',
					type: 'number',
					render: (value, onChange) => (
						<DropdownView
							label={null}
							model={value}
							onChanged={(m) => {
								onChange(m != null ? m.value : null);
							}}
							options={[
								{ value: 0, label: 'Pending' },
								{ value: 1, label: 'Finished' },
								{ value: 2, label: 'Failed' }
							]}
						/>
					)
				}
			});
		}

		return (
			<DataTableView
				model={model}
				columns={columns}
				rowKey={this.rowKey}
				expandedRowRender={this.handleExpandedRowRender}
				setBusy={this.props.setBusy}
				otherProps={{
					scroll: { x: 900 }
				}}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/accounting/shared/payments/list/payment-list.view.tsx